import { LoginRouteName } from '@shared/feature/login/application/routes/login.route-name';
import { LandingRouteName } from '@shared/feature/landing/application/routes/landing.route-name';

export function isPublicRoute(routeName: unknown): boolean {
  return (
    routeName === LoginRouteName.Login ||
    routeName === LandingRouteName.LandingError ||
    routeName === LandingRouteName.DefaultLanding
  );
}
